const bindEvents = () => {
	$(document).ready(() => {
		// This block of code helps to understand if the last event was caused by keyboard
		const KEYCODE_TAB = 9;
		const KEYCODE_ESC = 27;
		let lastKeyCode = null;
		let isShiftUsed = null;
		$(document)
			.on('click', '*', () => {
				lastKeyCode = null;
				isShiftUsed = null;
			});
		$(document)
			.on('keydown', '*', (e) => {
				lastKeyCode = e.keyCode;
				isShiftUsed = e.shiftKey;
			});
		$(document)
			.on('keyup', '*', (e) => {
				lastKeyCode = e.keyCode;
				isShiftUsed = e.shiftKey;
			});

		$('.menu-item-has-children a').on('blur', function (e) {
			const $parent = $(this).parent();
			const $activeElement = $(e.relatedTarget);
			if (
				$parent.not('.menu-item-has-children').is(':last-child') &&
				!(isShiftUsed && lastKeyCode === KEYCODE_TAB)
			) {
				const nextMenuItem = $(this).parents('.menu-item-has-children').first().next('li.menu-item');
				$(this).parents('.menu-item-has-children')
					.children('.da11y-submenu')
					.attr('aria-expanded', 'false')
					.trigger('mouseleave')
					.siblings('.sub-menu')
					.removeClass('da11y-submenu-show');
				// Focus on the next menu item if it exists and the last pressed key was not ESC
				if (nextMenuItem && lastKeyCode !== KEYCODE_ESC) {
					nextMenuItem.trigger('mouseenter');
				}
			}
			if (
				$parent.hasClass('menu-item-has-children') &&
				$parent.hasClass('et-show-dropdown') &&
				!$.contains($parent[0], $activeElement[0])
			) {
				$parent.removeClass('et-show-dropdown et-hover').find('.sub-menu.da11y-submenu-show').removeClass('da11y-submenu-show');
			}
		});
	});

	// We need to reset the mouseleave event with default delay
	$(window).on('load', () => {
		const ET_MENUS = $('ul.nav, ul.menu');
		ET_MENUS.each(function () {
			const $etMenu = $(this); // don't attach event handlers several times to the same menu
			$etMenu.find('li').off('mouseleave').on('mouseleave', function () {
				window.et_pb_toggle_nav_menu($(this), 'close');
			});
		});
	});
};

/**
 * @function init
 * @description Initializes modules.
 */

const init = () => {
	bindEvents();
};

export default init;



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/divi/navigation.js